import { Controller } from "@hotwired/stimulus";

// Repositions the hover card so it never falls behind table containers with
// `overflow: hidden`. The card defaults to `position: absolute`; on
// hover/focus we measure available room below the avatar and switch the card
// to `position: fixed`, anchored either below or above as space allows.
export default class extends Controller {
  connect() {
    this._items = Array.from(this.element.querySelectorAll(".people-stack__item"));
    this._enter = this._reposition.bind(this);
    this._items.forEach((item) => {
      item.addEventListener("mouseenter", this._enter);
      item.addEventListener("focusin", this._enter);
    });
  }

  disconnect() {
    if (!this._items) return;
    this._items.forEach((item) => {
      item.removeEventListener("mouseenter", this._enter);
      item.removeEventListener("focusin", this._enter);
    });
  }

  _reposition(event) {
    const item = event.currentTarget;
    const avatar = item.querySelector(".people-stack__avatar");
    const card = item.querySelector(".people-stack__card");
    if (!avatar || !card) return;

    const aRect = avatar.getBoundingClientRect();
    // The card is `display: flex` even when hidden (only opacity + pointer
    // are animated), so offsetWidth/Height already reflect its real size.
    const cardW = card.offsetWidth || 240;
    const cardH = card.offsetHeight || 80;

    const margin = 8;
    const overflowsBottom = aRect.bottom + margin + cardH > window.innerHeight;

    card.style.position = "fixed";
    card.style.left = `${aRect.left + aRect.width / 2}px`;

    if (overflowsBottom) {
      card.style.top = `${aRect.top - cardH - margin}px`;
      item.classList.add("is-card-above");
    } else {
      card.style.top = `${aRect.bottom + margin}px`;
      item.classList.remove("is-card-above");
    }

    // Clamp horizontally inside the viewport.
    const half = cardW / 2;
    const left = aRect.left + aRect.width / 2;
    if (left - half < margin) {
      card.style.left = `${margin + half}px`;
    } else if (left + half > window.innerWidth - margin) {
      card.style.left = `${window.innerWidth - margin - half}px`;
    }
  }
}
